import lookers from 'collections/lookers';
import { observer } from 'mobx-react-lite';
import { LookerPage } from 'pages';
import React from 'react';
import { Route } from 'react-router-dom';
import { routes } from 'routes';

const SalesController = observer(() => (
  <>
    <Route
      path={routes.lookers.sales.quotesPath()}
      exact
      render={(props) => <LookerPage {...props} title="Quotes | Sales | ERP" url={lookers.sales.quotes} />}
    />

    <Route
      path={routes.lookers.sales.analytics.bdmPerformancePath()}
      exact
      render={(props) => (
        <LookerPage {...props} title="BDM Performance | Sales | ERP" url={lookers.sales.analytics.bdmPerformance} />
      )}
    />

    <Route
      path={routes.lookers.sales.analytics.ordersCurrentMonthPath()}
      exact
      render={(props) => (
        <LookerPage
          {...props}
          title="Orders current month | Sales | ERP"
          url={lookers.sales.analytics.ordersCurrentMonth}
        />
      )}
    />

    <Route
      path={routes.lookers.sales.analytics.kamQuotationsPath()}
      exact
      render={(props) => (
        <LookerPage {...props} title="KAM Quotations | Sales | ERP" url={lookers.sales.analytics.kamQuotations} />
      )}
    />

    <Route
      path={routes.lookers.sales.analytics.monthlySalesMetricsPath()}
      exact
      render={(props) => (
        <LookerPage
          {...props}
          title="Monthly Sales Metrics | Sales | ERP"
          url={lookers.sales.analytics.monthlySalesMetricsPath}
        />
      )}
    />

    <Route
      path={routes.lookers.sales.analytics.npg()}
      exact
      render={(props) => <LookerPage {...props} title="NPG | Sales | ERP" url={lookers.sales.analytics.npg} />}
    />

    <Route
      path={routes.lookers.sales.analytics.clientDevelopmentDashboard()}
      exact
      render={(props) => (
        <LookerPage {...props} title="NPG | Sales | ERP" url={lookers.sales.analytics.clientDevelopmentDashboard} />
      )}
    />

    <Route
      path={routes.lookers.sales.analytics.wonDealsPath()}
      exact
      render={(props) => (
        <LookerPage {...props} title="Won deals | Sales | ERP" url={lookers.sales.analytics.wonDeals} />
      )}
    />

    <Route
      path={routes.lookers.sales.analytics.lostDealsPath()}
      exact
      render={(props) => (
        <LookerPage {...props} title="Lost deals | Sales | ERP" url={lookers.sales.analytics.lostDeals} />
      )}
    />

    <Route
      path={routes.lookers.sales.analytics.salesTargetsPath()}
      exact
      render={(props) => (
        <LookerPage {...props} title="Sales targets | Sales | ERP" url={lookers.sales.analytics.salesTargets} />
      )}
    />

    <Route
      path={routes.lookers.sales.analytics.salespeoplePerformancePath()}
      exact
      render={(props) => (
        <LookerPage
          {...props}
          title="Salespeople Performance | Sales | ERP"
          url={lookers.sales.analytics.salespeoplePerformance}
        />
      )}
    />

    <Route
      path={routes.lookers.sales.analytics.quickClosingClientsPath()}
      exact
      render={(props) => (
        <LookerPage
          {...props}
          title="Quick-Closing Clients | Sales | ERP"
          url={lookers.sales.analytics.quickClosingClients}
        />
      )}
    />

    <Route
      path={routes.lookers.sales.castingAndMolding.engineerFeedbackPath()}
      exact
      render={(props) => (
        <LookerPage {...props} title="Pricing | Sales | ERP" url={lookers.sales.castingAndMolding.engineerFeedback} />
      )}
    />

    <Route
      path={routes.lookers.sales.castingAndMolding.dfmPerformanceDashboardPath()}
      exact
      render={(props) => (
        <LookerPage
          {...props}
          title="DFM Performance Dashboard  | Sales | ERP"
          url={lookers.sales.castingAndMolding.dfmPerformanceDashboard}
        />
      )}
    />

    <Route
      path={routes.lookers.sales.analytics.spWeeklyDigestPath()}
      exact
      render={(props) => (
        <LookerPage {...props} title="SP weekly digest | Sales | ERP" url={lookers.sales.analytics.spWeeklyDigest} />
      )}
    />

    <Route
      path={routes.lookers.sales.analytics.saDashboardPath()}
      exact
      render={(props) => (
        <LookerPage {...props} title="SA dashboard | Sales | ERP" url={lookers.sales.analytics.saDashboard} />
      )}
    />

    <Route
      path={routes.lookers.sales.analytics.salesKpiPath()}
      exact
      render={(props) => (
        <LookerPage {...props} title="Sales KPI | Sales | ERP" url={lookers.sales.analytics.salesKpi} />
      )}
    />

    <Route
      path={routes.lookers.sales.analytics.emeaSalesKpisPath()}
      exact
      render={(props) => (
        <LookerPage {...props} title="EMEA Sales KPIs | Sales | ERP" url={lookers.sales.analytics.emeaSalesKpis} />
      )}
    />

    <Route
      path={routes.lookers.sales.analytics.customerOverduePath()}
      exact
      render={(props) => (
        <LookerPage {...props} title="Customer Overdue | Sales | ERP" url={lookers.sales.analytics.customerOverdue} />
      )}
    />

    <Route
      path={routes.lookers.sales.analytics.spScorecardPath()}
      exact
      render={(props) => (
        <LookerPage {...props} title="SP Scorecard | Sales | ERP" url={lookers.sales.analytics.spScoreCard} />
      )}
    />

    <Route
      path={routes.lookers.sales.analytics.salesTeamPerformanceComparisonYoyPath()}
      exact
      render={(props) => (
        <LookerPage
          {...props}
          title="Sales Team Performance Comparison YoY | Sales | ERP"
          url={lookers.sales.analytics.salesTeamPerformanceComparisonYoy}
        />
      )}
    />

    <Route
      path={routes.lookers.sales.analytics.speedToLeadAnalysisPath()}
      exact
      render={(props) => (
        <LookerPage
          {...props}
          title="Speed-to-Lead Analysis | Sales | ERP"
          url={lookers.sales.analytics.speedToLeadAnalysis}
        />
      )}
    />
  </>
));

export default SalesController;
